import ToggleHorizontal from './ToggleHorizontal'

export default ToggleHorizontal
